import React from "react";
import { motion } from "framer-motion";

const IsuStrategisCard = ({ data, index }) => {
  const getInitialPosition = () => {
    const column = index % 3;

    if (column === 0) {
      return { x: -50, opacity: 0 }; // 1st column
    } else if (column === 1) {
      return { y: 50, opacity: 0 }; // 2nd column
    } else {
      return { x: 50, opacity: 0 }; // 3rd column
    }
  };

  return (
    <motion.div
      className="flex flex-col justify-start items-start gap-2 bg-white p-5 rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-[filter] duration-300 ease-in-out overflow-hidden"
      initial={getInitialPosition()}
      whileInView={{
        x: 0,
        y: 0,
        opacity: 1,
      }}
      transition={{
        duration: 0.5,
        delay: 1 + 0.25 * index,
        ease: "easeInOut",
      }}
      viewport={{ once: true }}
    >
      <div className="flex justify-center items-center font-medium text-2xl text-white bg-cust-blue w-8 h-8 rounded-full">
        {index + 1}
      </div>
      <div className="text-cust-blue font-medium text-lg w-full leading-tight">
        {data.title}
      </div>
      <div
        className="w-full font-normal text-sm z-10"
        dangerouslySetInnerHTML={{ __html: data.description }}
      />
    </motion.div>
  );
};

export default IsuStrategisCard;
